
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-contents/consultants/[slug]",
      function () {
        return require("private-next-pages/solution-contents/consultants/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-contents/consultants/[slug]"])
      });
    }
  